import React from 'react';
import PropTypes from 'prop-types';
import { FaRegFileAlt, FaRegFolder } from 'react-icons/fa';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';

import { useTranslation } from 'react-i18next';

import { useToggle } from 'utils/hooks/useToggle';
import medalIcon from 'assets/images/medal-icon.svg';

import ProgramContentDescription from '../ProgramContentDescription';
import ProgramContentBenefits from '../ProgramContentBenefits';
import ProgramContentUnits from '../ProgramContentUnits';

const ProgramContentCard = ({ content }) => {
  const { t } = useTranslation();
  const [displayContent, setDisplayContent] = useToggle(true);

  const icon = {
    description: <FaRegFileAlt />,
    benefits: <img src={medalIcon} alt="medal icon" />,
    content: <FaRegFolder />,
  };

  const title = {
    description: t('evieApp.programInfo.descriptionTitle'),
    benefits: t('evieApp.programInfo.benefitsTitle'),
    content: t('evieApp.programInfo.contentTitle'),
  };

  const programContent = {
    description: <ProgramContentDescription />,
    benefits: <ProgramContentBenefits />,
    content: <ProgramContentUnits />,
  };

  return (
    <section className="program-content-card-container">
      <section type="button" className={`program-content-card ${content || ''}`}>
        <button type="button" className="program-content-card__title" onClick={setDisplayContent}>
          <div className="program-content-card__title_icon">{icon[content]}</div>
          <h2 className="program-content-card__title_label">{title[content]}</h2>
          {displayContent ? <IoIosArrowUp /> : <IoIosArrowDown />}
        </button>
        {displayContent ? programContent[content] : null}
      </section>
    </section>
  );
};

ProgramContentCard.propTypes = {
  content: PropTypes.oneOf(['description', 'benefits', 'content']).isRequired,
};

export default ProgramContentCard;
